module.exports = __webpack_public_path__ + "static/media/maintenance-logo@2x.4ebd3d6c.png";